export default __webpack_public_path__ + "static/media/docx.1a340507.svg";